// cookies-banner.js
// Banner de cookies para PublikaYA

class CookiesBanner {
    constructor() {
        this.cookieName = 'publikaya_cookies_accepted';
        this.bannerShown = false;
        this.init();
    }

    init() {
        // Verificar si ya se aceptaron las cookies
        if (this.getCookie(this.cookieName)) {
            return; // No mostrar banner si ya se aceptaron
        }

        // Crear y mostrar el banner después de un pequeño delay
        setTimeout(() => {
            this.createBanner();
            this.showBanner();
        }, 1000);
    }

    createBanner() {
        const existing = document.getElementById('cookies-banner');
        if (existing) {
            try { existing.remove(); } catch {}
        }

        const banner = document.createElement('div');
        banner.id = 'cookies-banner';
        banner.className = 'cookies-banner';

        const content = document.createElement('div');
        content.className = 'cookies-content';

        const text = document.createElement('div');
        text.className = 'cookies-text';
        const strong = document.createElement('strong');
        strong.textContent = 'PublikaYA.com';
        text.appendChild(strong);
        text.appendChild(document.createTextNode(' utiliza cookies para ofrecerte una mejor experiencia de usuario.'));

        const buttons = document.createElement('div');
        buttons.className = 'cookies-buttons';

        const acceptBtn = document.createElement('button');
        acceptBtn.id = 'accept-cookies';
        acceptBtn.className = 'btn-accept';
        acceptBtn.type = 'button';
        acceptBtn.textContent = 'Aceptar todas';

        const rejectBtn = document.createElement('button');
        rejectBtn.id = 'reject-cookies';
        rejectBtn.className = 'btn-reject';
        rejectBtn.type = 'button';
        rejectBtn.textContent = 'Rechazar todas';

        buttons.appendChild(acceptBtn);
        buttons.appendChild(rejectBtn);

        content.appendChild(text);
        content.appendChild(buttons);
        banner.appendChild(content);

        document.body.appendChild(banner);

        // Agregar event listeners
        document.getElementById('accept-cookies').addEventListener('click', () => this.acceptCookies());
        document.getElementById('reject-cookies').addEventListener('click', () => this.rejectCookies());
    }

    showBanner() {
        const banner = document.getElementById('cookies-banner');
        if (banner) {
            banner.classList.add('show');
            this.bannerShown = true;
        }
    }

    hideBanner() {
        const banner = document.getElementById('cookies-banner');
        if (banner) {
            banner.classList.add('hide');
            setTimeout(() => {
                banner.remove();
            }, 300);
            this.bannerShown = false;
        }
    }
    acceptCookies() {
        // Guardar preferencia de cookies aceptadas
        this.setCookie(this.cookieName, 'accepted', 365);
        console.log('Cookies aceptadas');
        this.hideBanner();
    }

    rejectCookies() {
        // Guardar preferencia de cookies rechazadas
        this.setCookie(this.cookieName, 'rejected', 365);
        console.log('Cookies rechazadas');
        this.hideBanner();
    }

    setCookie(name, value, days) {
        const expires = new Date();
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
        const isHttps = (function(){
            try { return window.location && window.location.protocol === 'https:'; } catch { return false; }
        })();
        // No es cookie sensible, pero igual aplicar hardening básico
        const secure = isHttps ? ';Secure' : '';
        document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax${secure}`;
    }

    getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
}

// Inicializar el banner cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
    new CookiesBanner();
});

// Exponer globalmente para uso manual si es necesario
window.CookiesBanner = CookiesBanner;
